import { Component, forwardRef, input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BuildingEquipmentItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-building-equipment-select',
  templateUrl: './building-equipment-select.component.html',
  styleUrl: './building-equipment-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingEquipmentSelectComponent),
      multi: true,
    },
  ],
})
export class BuildingEquipmentSelectComponent extends AbstractFormControl<string>{
  buildingEquipments = input.required<BuildingEquipmentItemDto[] | undefined>();
}
